import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AccountCreationSteps,
  FinancialAccountsCreationService,
  FinancialAccountTypes,
  PatriotActNoticeService,
} from '@brightside-web/desktop/feature/financial-accounts-core';
import { ProductCodes, ProductEligibilityService } from '@brightside-web/desktop/data-access/shared';

@Component({
    selector: 'brightside-web-spending-account-intro',
    templateUrl: './spending-account-intro.component.html',
    styleUrls: ['./spending-account-intro.component.scss'],
    standalone: false
})
export class SpendingAccountIntroComponent implements OnInit {
  introReasons = [{ key: 'SPENDING_INTRO_ITEM_1' }, { key: 'SPENDING_INTRO_ITEM_2' }, { key: 'SPENDING_INTRO_ITEM_3' }];

  showLearnMore: boolean;
  learnMoreContentCount = Array(3)
    .fill(0)
    .map((x, i) => i + 1);

  private readonly _patriotActNotice = inject(PatriotActNoticeService);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private faCreateSvc: FinancialAccountsCreationService,
    private productEligibilitySvc: ProductEligibilityService
  ) {}

  ngOnInit(): void {}

  routeUser() {
    this._patriotActNotice.continueAfterNoticeIfNeeded(FinancialAccountTypes.SPENDING, () => {
      this.nextStep();
    });
  }

  nextStep() {
    this.faCreateSvc.advanceStep(AccountCreationSteps.INTRO);
    this.router.navigate(['../verification'], { relativeTo: this.route });
  }

  navigateHome() {
    this.router.navigate(['home']);
  }
}
